export default "__VITE_ASSET__C96T5HaN__"